/**
 * Las propiedades publican varias URLs de servicio en `http`. La aplicación se
 * sirve por `https`, y un navegador bloquea el contenido mixto sin avisar al
 * usuario: la petición nunca sale y el formulario parece no responder.
 *
 * Se eleva el esquema en lugar de corregirlo en las propiedades porque esas las
 * publica el backend, no la Web.
 */
export const toHttps = (url: string): string => url.replace(/^http:/, 'https:');
